var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReconhecimento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41669 21.5313C3.51127 21.5313 2.76044 20.7804 2.76044 19.875V14.3542C2.76044 7.95002 7.9721 2.76044 14.3542 2.76044H19.875C20.7804 2.76044 21.5313 3.51127 21.5313 4.41669C21.5313 5.3221 20.7804 6.07294 19.875 6.07294H14.3542C9.78294 6.07294 6.07294 9.78294 6.07294 14.3542V19.875C6.07294 20.7804 5.3221 21.5313 4.41669 21.5313Z",
    fill: "url(#paint0_linear_1_1534)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5833 21.5313C47.6779 21.5313 46.9271 20.7804 46.9271 19.875V14.3542C46.9271 9.78294 43.2171 6.07294 38.6458 6.07294H33.125C32.2196 6.07294 31.4688 5.3221 31.4688 4.41669C31.4688 3.51127 32.2196 2.76044 33.125 2.76044H38.6458C45.0279 2.76044 50.2396 7.95002 50.2396 14.3542V19.875C50.2396 20.7804 49.4888 21.5313 48.5833 21.5313Z",
    fill: "url(#paint1_linear_1_1534)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6458 50.2396H35.3333C34.4279 50.2396 33.6771 49.4888 33.6771 48.5834C33.6771 47.678 34.4279 46.9271 35.3333 46.9271H38.6458C43.2171 46.9271 46.9271 43.2171 46.9271 38.6459V35.3334C46.9271 34.428 47.6779 33.6771 48.5833 33.6771C49.4887 33.6771 50.2396 34.428 50.2396 35.3334V38.6459C50.2396 45.05 45.0279 50.2396 38.6458 50.2396Z",
    fill: "url(#paint2_linear_1_1534)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 50.2396H14.3542C7.9721 50.2396 2.76044 45.05 2.76044 38.6458V33.125C2.76044 32.2196 3.51127 31.4688 4.41669 31.4688C5.3221 31.4688 6.07294 32.2196 6.07294 33.125V38.6458C6.07294 43.2171 9.78294 46.9271 14.3542 46.9271H19.875C20.7804 46.9271 21.5313 47.6779 21.5313 48.5833C21.5313 49.4888 20.7804 50.2396 19.875 50.2396Z",
    fill: "url(#paint3_linear_1_1534)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9166 40.3021H22.0833C16.7391 40.3021 13.8021 37.365 13.8021 32.0209V20.9792C13.8021 15.635 16.7391 12.6979 22.0833 12.6979H30.9166C36.2608 12.6979 39.1979 15.635 39.1979 20.9792V32.0209C39.1979 37.365 36.2608 40.3021 30.9166 40.3021ZM22.0833 16.0104C18.5941 16.0104 17.1146 17.49 17.1146 20.9792V32.0209C17.1146 35.51 18.5941 36.9896 22.0833 36.9896H30.9166C34.4058 36.9896 35.8854 35.51 35.8854 32.0209V20.9792C35.8854 17.49 34.4058 16.0104 30.9166 16.0104H22.0833Z",
    fill: "url(#paint4_linear_1_1534)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9584 28.1562H11.0417C10.1363 28.1562 9.38544 27.4054 9.38544 26.5C9.38544 25.5946 10.1363 24.8438 11.0417 24.8438H41.9584C42.8638 24.8438 43.6146 25.5946 43.6146 26.5C43.6146 27.4054 42.8638 28.1562 41.9584 28.1562Z",
    fill: "url(#paint5_linear_1_1534)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1534",
    x1: 12.1459,
    y1: 2.76044,
    x2: 12.1459,
    y2: 21.5313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3B7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1534",
    x1: 40.8542,
    y1: 2.76044,
    x2: 40.8542,
    y2: 21.5313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3B7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1534",
    x1: 41.9583,
    y1: 33.6771,
    x2: 41.9583,
    y2: 50.2396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3B7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1534",
    x1: 12.1459,
    y1: 31.4688,
    x2: 12.1459,
    y2: 50.2396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3B7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_1534",
    x1: 26.5,
    y1: 12.6979,
    x2: 26.5,
    y2: 40.3021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3B7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_1534",
    x1: 26.5,
    y1: 24.8438,
    x2: 26.5,
    y2: 28.1562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3B7B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconhecimento);
export default __webpack_public_path__ + "static/media/reconhecimento.bf6d3700be5e45d9b852dda1061f9f3e.svg";
export { ForwardRef as ReactComponent };